
import React, {Component} from "react";
import { AppMarketingHeader } from "./sectionWebsiteHeader";
import { AppMarketingFooter } from "./sectionWebsiteFooter";

import { CCallout } from '@coreui/react'

import("./marketing.css")

// const baseJPG="E512.jpg"
const aJPG=[{
    root: "E512_zombie",
    alt: "feeling Zombie tonight?",
    color: "#475e3f",
    max: 16
}, {
    root: "E512_vampire",
    alt: "in a Vampire mood?",
    color: "#530e2e",
    max: 20
}, {
    root: "E512_joker",
    alt: "the Joker!",
    color: "#1b0d17",
    max: 16
}, {
    root: "E512_ghost",
    alt: "whoohoo Ghost!",
    color: "#282e47",
    max: 16
}, {
    root: "E512_electric",
    alt: "feeling Electric?",
    color: "#172c71",
    max: 16
}, {
    root: "E512_clown",
    alt: "you are such a Clown!",
    color: "#91154f",
    max: 16
}, {
    root: "E512_metaverse",
    alt: "getting Metaverse ready...",
    color: "#a6394f",
    max: 16
}, {
    root: "E512_reggae",
    alt: "Reggae man!",
    color: "#1b6c26",
    max: 16
}];

const aGreetings=["Hello Albert", "Hey Al!", "Salut Albert!", "Hey mate!", "Cmon Albert!"];

const objLoop={
    bIsAnimateStarted: false,
    aJPG: aJPG.slice(),
    iCycle: 0,
    direction: 1,
    pace: 160,
    aEltLetter: [],                 // all elt to make letter effects on home page
    aEltImage: [],                  // all image elt to contain morphed images for the selected one
    eltImg: null,                   // the elt where all images get displayed
    eltText: null                   // changing text depending on the selected one
}

class AppMarketing extends Component {

    constructor(props) {
        super(props);
        let that=this;
        that._initElements()
            .then(function(){
                if(!objLoop.bIsAnimateStarted) {
                    objLoop.bIsAnimateStarted=true;
                    let iImage=that.resetImages();
                    that.animateImage(iImage);        
                }
            })
            .catch(function(){
                return;
            });
    }

    // we need UI to be loaded before we can do anything...
    async _LoadUI () {
        return new Promise((resolve, reject) => {
            let eltImg=document.getElementById("loopImage");
            let eltText=document.getElementById("loopImageText");
            let bIsInit=(eltImg!==null && eltText!==null); 
            if(!bIsInit) {
                reject();
            }
            else {
                // now init!
                objLoop.eltText= eltText;
                objLoop.eltImg= eltImg;
                for (var i=0; i<=20; i++) {
                    let _id="loopImageSrc_"+String(i).padStart(2, '0');
                    let eltTemp=document.getElementById(_id);
                    if(!eltTemp) {          // bad case???
                        bIsInit=false;
                    }
                    objLoop.aEltImage.push(eltTemp);
                }

                if(!bIsInit) {
                    objLoop.aEltImage=[];
                    reject();
                }
                else {
                    resolve();
                }
            }
        });
    }

    async _initElements () {
        // loadUI ... until it works...
        let that=this;
        return new Promise((resolve, reject) => {
            let _timer=setInterval(function(){
                that._LoadUI()
                    .then(function(){
                        clearInterval(_timer);
                        resolve();
                    })
                    .catch(function(){
                        // we wait...
                        return;
                    })        
            }, 100);
        });
    }

    resetImages() {
        // replenish choices?? 
        if(objLoop.aJPG.length===0) {
            objLoop.aJPG=aJPG.slice();
        }

        // get new image...
        let iRnd=Math.random() * objLoop.aJPG.length - 0.00000001;
        let iImage=Math.floor(iRnd);

        // get new greeting...
        iRnd=Math.random() * aGreetings.length - 0.00000001;
        let iGreet=Math.floor(iRnd);
        objLoop.eltText.innerHTML=aGreetings[iGreet];
        objLoop.eltText.style.background=objLoop.aJPG[iImage].color;
            
        // show them image and text
        objLoop.eltImg.classList.remove("noshow");
        objLoop.eltText.classList.remove("noshow");

        // set the new guy
        objLoop.eltImg.src="/assets/images/e512/E512.jpg";
        objLoop.aEltImage[0].src="/assets/images/e512/E512.jpg";
        for (var i=1; i<=objLoop.aJPG[iImage].max; i++) {
            objLoop.aEltImage[i].src= "/assets/images/e512/"+objLoop.aJPG[iImage].root+"_"+i+".jpg";
        }

        return iImage;
    }

    _showNextCycle(){
        let iNext= objLoop.iCycle + objLoop.direction;
        objLoop.iCycle= iNext;
        objLoop.eltImg.src=objLoop.aEltImage[iNext].src
    }

    _animateText(iImage, bIn){
        let _animateLetterOut=function(elt, i) {
            setTimeout(function() {
                elt[i].className = 'letter out';
            }, i*60);
        }
          
        function _animateLetterIn(elt, i) {
            setTimeout(function() {
                elt[i].className = 'letter in';
            }, 250+(i*40));
        }
  
        for (var i = 0; i < objLoop.aEltLetter.length; i++) {
            if(bIn) {
                objLoop.aEltLetter[i].className = 'letter behind';
                _animateLetterIn(objLoop.aEltLetter, i);
            }
            else {
                _animateLetterOut(objLoop.aEltLetter, i);
            }
        }
    }

    animateTextIn(iImage) {
        // split letters
        let strOld=objLoop.eltText.innerHTML;
        objLoop.eltText.innerHTML = '';
        objLoop.aEltLetter = [];
        for (var i = 0; i < strOld.length; i++) {
            var eltLetter = document.createElement('span');
            eltLetter.className = 'letter';
            eltLetter.innerHTML = strOld.charAt(i).replace(" ", "&nbsp;");
            objLoop.eltText.appendChild(eltLetter);
            objLoop.aEltLetter.push(eltLetter);
        }

        return this._animateText(iImage, true);
    }

    animateTextOut(iImage) {
        return this._animateText(iImage, false);
    }

    animateImage(iImage) {
        let that=this;

        if(objLoop.aEltImage.length>0) {
            let max=objLoop.aJPG[iImage].max;
            let isTopReached=false;
            let isBottomReached=false;

            // change of direction?
            switch(objLoop.iCycle) {
                case max: 
                    isTopReached=true;
                    objLoop.direction= -1;
                    objLoop.pace=1500;          // we wait at top morphed image
                    break;

                case (max-1):
                    if(objLoop.direction===-1) {
                        objLoop.pace=60;        // we go down the morphing
                        this.animateTextOut(iImage);
                    }
                    break;

                case 0: 
                    isBottomReached=true;
                    objLoop.direction= 1;
                    objLoop.pace=1800;          // we wait at original image 
                    break;
                case 1: 
                    if(objLoop.direction===1) {
                        objLoop.pace=220;       // we go up the morphing
                    }
                    break;
                case 4: 
                    if(objLoop.direction===1) {
                        objLoop.pace=180;       // we accelerate the morphing
                    }
                    break;

                case 6: 
                    if(objLoop.direction===-1) {
                        objLoop.pace=100;       // we deccelerate down to original
                        objLoop.eltText.classList.remove("grow")
                        objLoop.eltText.classList.add("shrinkToTiny")
                    }
                    break;
                case 10: 
                    if(objLoop.direction===1) {
                        objLoop.pace=120;       // we accelerate up the morphing
                    }
                    break;

                default:
                    break;
            }

            this._showNextCycle();
            if(isBottomReached) {
                objLoop.aJPG.splice(iImage, 1);     // remove this choice
                iImage=this.resetImages();
                objLoop.eltText.innerHTML=objLoop.aJPG[iImage].alt;
                objLoop.eltText.classList.remove("shrinkToTiny")
                objLoop.eltText.classList.add("grow")
                this.animateTextIn(iImage);
            }

            // nothing in case of top
            if(isTopReached) {}

            setTimeout(function(){
                that.animateImage(iImage);
            }, objLoop.pace);
        }
    }

    onOpenApp() {
        window.location.replace("/app/dashboard");
    }

    renderCallOut( ){
        return (
            <CCallout color="success">
            <a href= "/app/artwall" target="_blank"> 
            <div className="callout_image">
            <video width="100" height="100" loop autoPlay muted playsInline >
                <source src="/assets/images/womenai.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="callout_text">
            <br />
                <div>WomenAI</div>
                <div>2,500 NFTs for sale!</div>
            </div>
            </a>
        </CCallout>

        );
    }

    renderHero() {
        return (
            <section className="section">

                <div>
                    <div className="blur-section-1"></div>
                    <div className="container is--bigger">

                        {/* this.renderCallOut() */}
                        
                        <div className="grid is-mobile">
                            <div className="div-block-3"></div>
                            <div className="grid_item is--hero-img1">
                                <div className="div-img1">
                                    {/* <img src={"/assets/images/emc2/"+this.state.character.image} alt="" className="image" /> */}
                                    <img src="/assets/images/e512/E512.jpg" alt="" className="image noshow" id="loopImage" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_00" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_01" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_02" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_03" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_04" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_05" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_06" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_07" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_08" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_09" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_10" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_11" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_12" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_13" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_14" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_15" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_16" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_17" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_18" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_19" />
                                    <img src="" alt="" className="image noshow" id="loopImageSrc_20" />
                                </div>
                                <div className="div-img1-legend rotating text">
                                    <div className="word text-span-4 aboveImage noshow" id="loopImageText"></div>
                                </div>

                            </div>
                            <div className="grid_item is--hero-content1">
                                <div className="is--text-heading">
                                    <h1 className="heading-4">Join the clan<br />
                                    <span className="text-span-3">Because you are </span><span className="text-span-3 nowrap">Morph it!</span></h1>
                                </div>
                                <div className="is--text-block-header">
                                    <span>Morph yourself into characters... </span> 
                                    <span>Upload your picture, </span>
                                    <span>morph it, and mint it as an NFT!</span>
                                    <br />
                                    <br />
                                    <span>The ai-generated Art Marketplace on Cardano!</span>
                                </div>
                                <div className="buttons-flex">
                                    <div className="button" onClick={() => {this.onOpenApp()}}>
                                        <div className="test is--first">Enter APP...</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );    
    }

    render() {
        return (
            <section className="wrapper">
                
                <AppMarketingHeader />

                {this.renderHero()}

                <AppMarketingFooter />

            </section>
        );
    }    

}

export default AppMarketing;
